import 'css-chunksrc/client/scenes/moveElement/projectsSelection/checkbox/styles.scss';export default {
  "checkbox": "_checkbox_1sekn_1",
  "checked": "_checked_1sekn_12"
};